exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  background-color: rgba(0,0,0,0.85);\n  color: #fff;\n  font-family: 'Questrial', sans-serif;\n  display: block;\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  opacity: 0.1;\n  -webkit-transition: opacity 200ms ease-in;\n  transition: opacity 200ms ease-in;\n}\n:host:hover {\n  opacity: 1;\n}\n.rm-menu {\n  height: 50px;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n}\n.rm-menu .nav-item {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  text-align: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n/*\nlist-style none\njustify-content space-between\nheight 100%\npadding 0\nmargin 0\n\n.rm-option\n  padding 3em 3em\n  text-align center\n  &:hover\n    text-decoration underline\n    cursor pointer\n    background linear-gradient(white, white, #f4f4f4)\n*/\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/davcocom/Documents/Documents - David’s MacBook Pro/resume/resume-onepage/src/app/menu/menu.component.styl
// module id = ../../../../../src/app/menu/menu.component.styl
// module chunks = main